import {createSlice} from "@reduxjs/toolkit";

const initialAddContestCategoryState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  newContestCategory: {},
  contestCategoryForEdit: {},
  editContestCategory: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const AddContestCategorySlice = createSlice({
  
  name: "addContestCategory",
  initialState: initialAddContestCategoryState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    createContestCategory: (state, action) => {
      const { newContestCategory } = action.payload;
      state.error = null;
      state.newContestCategory = newContestCategory;
    },
    singleItemFetched: (state, action) => {
      console.log("action.payload.contestCategoryForEdit",action.payload.contestCategoryForEdit);
      state.actionsLoading = false;
      state.contestCategoryForEdit = action.payload.contestCategoryForEdit;
      state.error = null;
    },
    updateContestCategory: (state, action) => {
      const { editContestCategory } = action.payload;
      state.error = null;
      state.editContestCategory = editContestCategory;
    },
  }
});
